import EventBus from './utils/EventBus';
import { getWindowScrollTop, throttle, debounce, isTouch, detectIEEdge } from './utils';
import MagicHeader from './MagicHeader';
import Swiper from 'swiper/dist/js/swiper.min.js';
import ContentScroller from './ContentScroller';
import Share from './Share';
import Wow from 'wow.js';
import VideoThreeSixty from './VideoThreeSixty';

class App {
  constructor() {
    this.eventBus = EventBus;
    this.app = {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight
    };
    this.languageSelector = document.querySelector('.js-language-select');
    this.header = document.querySelector('.js-header');
    this.magicHeader = new MagicHeader(this.header, this.eventBus);
    this.galleries = document.querySelectorAll('.swiper-container');
    this.foregroundIntro = document.querySelector('.foreground--intro');
    this.foregroundArticle = document.querySelector('.foreground--article');
    this.contentScroller = document.querySelector('.js-content-scroller');
    this.vph = document.querySelectorAll('.js-viewport-height');
    this.video360 = document.querySelector('.js-video-360');

    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.removeIntro = this.removeIntro.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  init() {
    if (detectIEEdge()) {
      document.body.classList.add('no-support-svg');
    }

    this.bindEventListeners();
    this.checkShare();

    // size full screen elements to fit in mobile devices.
    this.applyVph();

    if (!!this.contentScroller) {
      this.cs = new ContentScroller(this.contentScroller, this.eventBus);
    }

    if (this.video360) {
      const videoUrl = this.video360.dataset.url;
      const v = new VideoThreeSixty(this.video360, videoUrl);
    }

    if (this.galleries.length > 0) {
      const swipers = [];
      const swiperOptions = {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        spaceBetween: 24,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: { slidesPerView: 1, spaceBetween: 16 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 3 },
          1440: { slidesPerView: 4 },
          1980: { slidesPerView: 4 },
          6000: { slidesPerView: 5 }
        }
      };
      
      this.galleries.forEach((gallery, idx) => {
        const id = gallery.getAttribute('id');
        swipers[idx] = new Swiper(`#${id}`, swiperOptions);
      });
    }

    const wow = new Wow({
      boxClass:     'wow',
      animateClass: 'animated',
      offset:       0,
      mobile:       true, 
      live:         true   
    });
    wow.init();
  }

  bindEventListeners() {
    const debouncedResize = debounce(this.handleResize, 100);
    window.addEventListener('scroll', this.handleScroll);

    isTouch()
      ? window.addEventListener('orientationchange', debouncedResize)
      : window.addEventListener('resize', debouncedResize);

    if (this.languageSelector) {
      this.languageSelector.addEventListener('change', this.handleLanguageChange);
    }

    // if (!!this.foregroundIntro && !!this.foregroundArticle) {
    //   window.addEventListener('scroll', this.removeIntro);
    // }
  }

  removeIntro() {
    const scrollTop = getWindowScrollTop();
    const threshold = window.innerHeight / 10;

    if (scrollTop > threshold) {
      setTimeout(() => {
        this.foregroundIntro.style.height = 0;
        this.foregroundArticle.style.height = '100%';
      }, 0);
    }
  }

  getWindowSize() {
    return {
      // width: window.innerWidth,
      // height: window.innerHeight
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    }
  }

  applyVph() {
    this.vph.forEach(vph => {
      vph.style.height = `${window.innerHeight}px`;
    });
  }

  handleScroll() {
    this.eventBus.publish('scrollPosition', getWindowScrollTop());
  }

  handleResize() {
    this.eventBus.publish('resize', this.getWindowSize());
    this.applyVph();
  }

  handleLanguageChange(evt) {
    const value = evt.target.value;
    const url = `${window.location.origin}/${value}`;
    window.location = url;
  }

  checkShare() {
    /* share buttons */
    const shareButtons = document.querySelectorAll('[data-share]');

    if(shareButtons.length) {
      for(let i = 0; i < shareButtons.length; i++) {
        new Share(shareButtons[i]);
      }
    }
  }
}

export default App;